<template>
  <div>
    <div></div>
    <!-- Assignment Multi Update Modal Start -->
    <b-button
      style="font-size: 0.675rem"
      class="mt-2"
      size="sm"
      @click="Overlock_column_value == '0' ? CommonLockUnLock(Overlock_item, 'Open') : ''"
      :variant="Overlock_column_value == '0' ? 'danger' : 'success'"
    >
      <b v-if="Overlock_column_value == '0'"><i class="fa fa-lock mr-1 lg"></i>Open</b>
      <b v-else> <i class="fa fa-unlock mr-1 lg"></i>Locked </b>
    </b-button>

    <b-modal
      id="Common_modal-lock-conf"
      ref="Common_modal-lock-conf"
      :title="title +' - '+ Overlock_JOBNO"
      size="lg"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <div class="row">
        <div class="col-md-2 text-right">
          <label for="ColumnName">Reason :</label>
        </div>
        <div class="col-md-10 mt-2">
          <b-form-textarea
            :formatter="capitalizeAll"
            rows="5"
            id="name-input"
            v-model="lockPanelDetail.lockReason"
            required
          ></b-form-textarea>
        </div>

        <div class="col-md-12 text-center">
          <center>
            <b-button
              v-if="lockPanelDetail.lockReason"
              :disabled="lockPanelDetail.Overlock_button ? true : false"
              variant="success"
              style="font-size: 11px"
              size="sm"
              class="mt-2"
              @click="UnlockOverseas"
              >Send</b-button
            >
            <b-button
              @click="CommoncloseCommonLockUnLockConfirm"
              style="font-size: 11px"
              size="sm"
              class="mt-2"
              variant="danger"
              >Close</b-button
            >
          </center>
        </div>
      </div>
    </b-modal>
    <!-- Assignment Summary Modal End -->
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";
import ClientUserService from "../../services/ClientUserService.js";

export default {
  props: [
    "title",
    "Overlock_item",
    "Overlock_JOBNO",
    "Overlock_allModuleId",
    "Overlock_table_name",
    "Overlock_table_key",
    "Overlock_table_value",
    "Overlock_column_key",
    "Overlock_column_value",
    "Overlock_module_type",
    // "Overlock_Function",
  ],

  beforeMount() {
    if (this.Overlock_all_module_id != "" && this.Filter_Flag == true) {
      this.getServicesData();
      this.getAssignmentMultiUpdate();
    }
  },

  data() {
    return {
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      Filter_Flag: false,

      lockPanelDetail: {
        //Overlock_item
        Overlock_item: this.Overlock_item,
        Overlock_JOBNO: this.Overlock_JOBNO,
        Overlock_allModuleId: this.Overlock_allModuleId,
        Overlock_table_name: this.Overlock_table_name,
        Overlock_table_key: this.Overlock_table_key,
        Overlock_table_value: this.Overlock_table_value,
        Overlock_column_key: this.Overlock_column_key,
        Overlock_column_value: this.Overlock_column_value,
        Overlock_module_type: this.Overlock_module_type,
      },
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
  },

  computed: {},
  watch: {},
  methods: {
    triggerFunction() {
      // this.$emit("Overlock_Function");
    },
    UnlockOverseas() {
      if (this.lockPanelDetail.lockReason && this.Overlock_column_value == 0) {
        this.isLoading = true;
        let tit = "";
        if (this.Overlock_column_value == 0) {
          tit = "Open Overseas";
        }
        let paylod = {
          itemCode: "OpenOverseasAssignment",
          Overlock_table_name: this.Overlock_table_name,
          Overlock_table_key: this.Overlock_table_key,
          Overlock_table_value: this.Overlock_table_value,
          Overlock_column_key: this.Overlock_column_key,
          Overlock_column_value: this.Overlock_column_value == 0 ? 1 : 0,
          Title: tit,
          JOBNO: this.Overlock_JOBNO,
          allModuleId: this.Overlock_allModuleId,
          module_type: this.Overlock_module_type,
          Type: this.lockPanelDetail.Overlock_Type,
          lockReason: this.lockPanelDetail.lockReason,
        };

        ClientUserService.getAllOverseaLock(JSON.stringify(paylod))
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              this.alert.content = data.MSG;
              this.lockPanelDetail.lockReason = "";
              this.CommoncloseCommonLockUnLockConfirm();
              this.$refs["addPop"].open();
              this.$refs["Common_modal-lock-conf"].hide();
              // this.triggerFunction();
            }

            this.lockPanelDetail.Overlock_button = false;
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on Proforma Error: ", error);
          });
      }
    },
    CommonLockUnLock(items, type) {
      // console.log("Priyanshu Singh=>", items);
      // console.log("Priyanshu Singh type=>", type);
      this.lockPanelDetail.Overlock_allModuleId = items.allModuleId;
      this.lockPanelDetail.Overlock_ffExportFclId = 0;
      this.lockPanelDetail.Overlock_ffExportFclSeries = items.mainSalesSeries;
      this.lockPanelDetail.Overlock_Type = type;
      this.lockPanelDetail.is_locked = items.is_misc_locked;
      this.lockPanelDetail.locked_counter = items.all_locked_counter;
      console.log("Priyanshu Singh=>", items);
      // return false;
      this.$refs["Common_modal-lock-conf"].show();
    },
    CommoncloseCommonLockUnLockConfirm() {
      this.$refs["Common_modal-lock-conf"].hide();
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// commonOverseaUnLock.vue?97e54e16